export default "__VITE_ASSET__CSbmBhEy__"